/**
 * Phase 98 (Lot 3) — Redirect Réassort → Tournée de réappro à 1 distributeur.
 *
 * L'ancien module "Réassort" est fusionné avec les Tournées. Cette route
 * crée automatiquement une nouvelle tournée avec le distributeur courant
 * comme unique cible, puis redirige vers le détail de la tournée.
 *
 * Bénéfices :
 *   - 1 seul module (fini le sous-menu caché)
 *   - Choix DLC manuel disponible aussi pour un réassort simple
 *   - Le n° de slot est affiché (regret du user sur l'ancien module)
 */
import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function DistributorRestockRedirect() {
  const { id: distributorId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.post("/refill-tours", {
          selected_distributor_ids: [distributorId],
          operator_name: "",
        });
        if (cancelled) return;
        toast.success(`Nouvelle tournée créée pour ce distributeur (${data.reference || ""})`);
        navigate(`/tournees-reappro/${data.id}`, { replace: true });
      } catch (e) {
        if (cancelled) return;
        toast.error(e?.response?.data?.detail || "Impossible de créer la tournée. Vérifiez la configuration.");
        navigate("/tournees-reappro", { replace: true });
      }
    })();
    return () => { cancelled = true; };
  }, [distributorId, navigate]);

  return (
    <div className="flex items-center justify-center py-24 text-[#575A57]" data-testid="restock-redirect-loading">
      <div className="text-center space-y-3">
        <Loader2 className="w-8 h-8 mx-auto animate-spin text-[#1F4E3D]" />
        <div className="text-sm">Création d&apos;une tournée de réappro pour ce distributeur…</div>
        <div className="text-xs text-[#A3A6A3]">
          Le module Réassort est désormais unifié avec les Tournées (Phase 98).
        </div>
      </div>
    </div>
  );
}
